import { lazyPage } from '@/lib/lazy-load'

const MyTeamsPage = lazyPage(() => import('./MyTeamsPage'))
export default MyTeamsPage
